import React from "react";
import { adminAxios } from "../../axiosInstance";
import { fetchOnlyData } from "../../utility/adminApi";
import { useQuery } from "@tanstack/react-query";
import { formatNumbers } from "../../components/formatNumbers";

function ProfileSaleStats({ currencySymbol }) {
  const { data: salesStat, error } = useQuery({
    queryKey: ["profile-stat"],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData("users/profile-stat"),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4">
      <div className="bg-orange-500 text-white p-4 rounded">
        <p className="text-sm">Amount</p>
        <p className="text-2xl font-bold">
          {currencySymbol}
          {formatNumbers(salesStat?.serviceFee)}
        </p>
      </div>
      <div className="bg-purple-600 text-white p-4 rounded">
        <p className="text-sm">Sales this month</p>
        <p className="text-2xl font-bold">
          {currencySymbol}
          {formatNumbers(salesStat?.thisMonthSales)}
        </p>
      </div>
      <div className="bg-fuchsia-600 text-white p-4 rounded">
        <p className="text-sm">Rate</p>
        <p className="text-2xl font-bold">{salesStat?.percentage}%</p>
      </div>
      <div className="bg-rose-600 text-white p-4 rounded">
        <p className="text-sm">Due date</p>
        <p className="text-2xl font-bold">{salesStat?.dueDate}</p>
      </div>
    </div>
  );
}

export default ProfileSaleStats;
